import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "handlebar-selection" }
const _hoisted_2 = { class: "handlebar-selection__filters" }
const _hoisted_3 = { class: "handlebar-selection__content" }
const _hoisted_4 = { class: "handlebar-selection__buttons" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useHandlebarStore } from '@/store/handlebarStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useBikeStore } from '@/store/bikeStore'
import { useRouter } from 'vue-router'
import HandlebarFilters from '@/components/setup/handlebar/HandlebarFilters.vue'
import HandlebarSelection from '@/components/setup/handlebar/HandlebarSelection.vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { BikeHoodsType } from '@/types/bike'
import { PreviewImage } from '@/types/preview'


export default /*@__PURE__*/_defineComponent({
  __name: 'HandlebarSelectionView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const handlebarStore = useHandlebarStore()
const measurementStore = useMeasurementStore()
const bikeStore = useBikeStore()
const selected = ref()

handlebarStore.reset()

const { bikePreview } = storeToRefs(bikeStore)

const select = (pedal: any) => {
  selected.value = pedal
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.handlebar.active = selected.value

    switch (bikeStore.bikeHoodsType) {
      case BikeHoodsType.DROPBAR:
        bikePreview.value = PreviewImage.DROPBAR_BIKE
        break

      case BikeHoodsType.FLATBAR:
        bikePreview.value = PreviewImage.FLATBAR_BIKE
        break

      case BikeHoodsType.TRIBAR:
        bikePreview.value = PreviewImage.TRIBAR_BIKE
        break

      default:
        bikePreview.value = PreviewImage.DROPBAR_BIKE
        break
    }
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HandlebarFilters)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, _toDisplayString(_unref(t)('setup.handlebar.selection')), 1),
      _createVNode(HandlebarSelection, { onSelect: select }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(BfButton), {
          type: _unref(ButtonType).Outlined,
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_unref(BfButton), {
          state: selected.value ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled,
          onClick: install
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.install')), 1)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ])
  ]))
}
}

})